import { ACTIONS } from "../../Models/ENUM";
import CONQUER from "../CONQUER";
import AvatarInstance from "./AvatarInstance";
import LOG, { log } from "../../UTIL/LOG";

class Avatars 
{
  private conquer   : CONQUER;
  public pool       : any = [];
  public data       : any = {};
  public ME         : AvatarInstance | any = {};

  private listeners : any = {};

  public constructor( conquer: CONQUER) 
  {
    this.conquer  = conquer;
  }

  public init()
  {
    this.ME       = this.pushInstance( this.conquer.User );
  }

  /*=============== 


    GET
    get() - get all, set conquer.Room.pool
    get('avatarID1')
    get(['avatarID1','avatarID2'])

    ================*/

  public async get( vars?:any ): Promise<any> 
  {
    if( !vars ) return; 

    if( typeof vars == "string" )
    {
      if( this.data[ vars ] ) return Promise.resolve( this.data[ vars ] );

      let value = await this.conquer.do( ACTIONS.AVATAR_GETONE, { _id:vars });
      return Promise.resolve( this.pushInstance( value ) );
    }

    return Promise.resolve();

    if( Array.isArray( vars )) 
    { 
      let value = await this.conquer.do( ACTIONS.AVATAR_GET, vars );
      return Promise.resolve( this.pushInstance( value ) ); 
    }

    // GET ALL
  
    let output : any  = [];
    let array   = await this.conquer.do( ACTIONS.AVATAR_GET, vars );

    for ( var n in array ) output.push( this.pushInstance( array[n] ) );
  
    return Promise.resolve();//output
  }

  public async load( avatarID:any, callback:Function )
  {
    if( this.data[ avatarID ] ) return callback( this.data[ avatarID ] );

    let isLoading = this.listeners[ avatarID ];

    if( !isLoading ) this.listeners[ avatarID ] = [];
 
    this.listeners[ avatarID ].push( callback );

    if( isLoading ) return;

    let value = await this.conquer.do( ACTIONS.AVATAR_GETONE, { _id:avatarID });
    let Avatar = this.pushInstance( value );

    for( let n in this.listeners[ avatarID ] ) this.listeners[ avatarID ][ n ]( Avatar );
  }
 
  public pushInstance( vars:any ) : AvatarInstance
  {
    if( this.data[ vars.avatarID ] ) return this.data[ vars.avatarID ];

    let instance : AvatarInstance = new AvatarInstance( this.conquer, vars );

    this.pool.push( instance );
    this.data[ instance.avatarID ] = instance;

    return instance;
  };

  /*=============== 


    SET
    

  ================*/

  public async set( toFollowID: any ): Promise<any> 
  {
    var friendship = await this.conquer.do( ACTIONS.FOLLOWERS_SET, { toFollowID: toFollowID });
    return Promise.resolve( friendship );
  }

  public async setUserPhoto( userPhoto:string ):Promise<any> 
  {
    let response = await this.conquer.do( ACTIONS.AVATAR_PHOTO_SET, { avatarID: this.conquer.User.avatarID, userPhoto:userPhoto });

    //if( !response.error ) this.conquer.User.userPhoto = `${response}?${Date.now()}`;

    return response;
  }

  public async getUserPhoto():Promise<any> 
  {
    return await this.conquer.do( ACTIONS.AVATAR_PHOTO_GET, { avatarID: this.conquer.User.avatarID });
  }
}

export default Avatars;
